module.exports = "/_next/static/images/Firmware@2x-4bee1e87afd8f2180c29e17ba9fc7992.png";